import propTypes from 'prop-types';

export const navBtnPropTypes = propTypes.arrayOf(
  propTypes.shape( {
    section: propTypes.string,
    text: propTypes.string,
  } ),
);